(function () {
  const PAGE_RULES = {
    index: {
      minVisibleTime: 500,
      maxWait: 2500,
      images: [
        'moving-banner .slide-item:first-child img.banner-img[fetchpriority="high"], moving-banner .slide-item:first-child img.banner-img'
      ],
      texts: []
    },

    collection: {
      minVisibleTime: 250,
      maxWait: 1000,
      images: [],
      texts: [
        '.shopify-section--collection-banner h1',
        '.shopify-section--collection-banner .prose'
      ]
    },

    default: {
      minVisibleTime: 250,
      maxWait: 500,
      images: [],
      texts: []
    }
  };

  function wait(milliseconds) {
    return new Promise((resolve) => {
      setTimeout(resolve, milliseconds);
    });
  }

  function getPageType() {
    return document.body.dataset.pageType || 'default';
  }

  function getCurrentRule() {
    const pageType = getPageType();

    if (pageType === 'index') {
      return PAGE_RULES.index;
    }

    if (pageType === 'collection') {
      return PAGE_RULES.collection;
    }

    return PAGE_RULES.default;
  }

  function waitForImageSelector(selector) {
    const image = document.querySelector(selector);

    return new Promise((resolve) => {
      if (!image) {
        resolve();
        return;
      }

      if (image.complete && image.naturalWidth > 0) {
        if (image.decode) {
          image.decode().catch(() => {}).finally(resolve);
        } else {
          resolve();
        }

        return;
      }

      image.addEventListener('load', resolve, { once: true });
      image.addEventListener('error', resolve, { once: true });
    });
  }

  function waitForTextSelector(selector) {
    const element = document.querySelector(selector);

    if (!element) {
      return Promise.resolve();
    }

    if (element.textContent.trim().length > 0) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      const observer = new MutationObserver(() => {
        if (element.textContent.trim().length > 0) {
          observer.disconnect();
          resolve();
        }
      });

      observer.observe(element, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  function hideLoader(loader) {
    document.body.classList.remove('loading');
    document.body.classList.add('loaded');

    if (!loader) return;

    loader.classList.add('is-hidden');

    setTimeout(() => {
      loader.style.display = 'none';
    }, 300);
  }

  async function initLoader() {
    const loader = document.getElementById('loader');
    const rule = getCurrentRule();

    if (loader) {
      loader.style.display = 'flex';
    }

    document.body.classList.remove('page-transition');
    document.body.classList.add('loading');
    document.body.classList.remove('loaded');

    const startedAt = performance.now();

    const requiredTasks = [
      ...rule.images.map(waitForImageSelector),
      ...rule.texts.map(waitForTextSelector)
    ];

    await Promise.race([
      Promise.all(requiredTasks),
      wait(rule.maxWait)
    ]);

    const elapsed = performance.now() - startedAt;
    await wait(Math.max(0, rule.minVisibleTime - elapsed));

    hideLoader(loader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoader, { once: true });
  } else {
    initLoader();
  }
})();